import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {LinkSchema} from './link'

export const PrimerComponentSectionIntroSchema = buildEntrySchemaFor('primerComponentSectionIntro', {
  fields: z.object({
    align: z.literal('start').or(z.literal('center')),
    heading: z.string(),
    description: RichTextSchema.optional(),
    link: LinkSchema.optional(),
  }),
})

export type PrimerComponentSectionIntro = z.infer<typeof PrimerComponentSectionIntroSchema>
